import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, TrendingUp, ArrowUpCircle, Bell, User } from 'lucide-react';

const NAV_ITEMS = [
  { to: '/dashboard',       label: 'Home',       Icon: Home },
  { to: '/invest',          label: 'Invest',     Icon: TrendingUp },
  { to: '/withdraw',        label: 'Withdraw',   Icon: ArrowUpCircle },
  { to: '/notifications',   label: 'Alerts',     Icon: Bell },
  { to: '/profile',         label: 'Profile',    Icon: User },
];

export default function BottomNav() {
  const { pathname } = useLocation();

  return (
    <nav className="bottom-nav">
      <div className="flex items-center justify-around">
        {NAV_ITEMS.map(({ to, label, Icon }) => {
          const isActive = pathname.startsWith(to);
          return (
            <NavLink
              key={to}
              to={to}
              className="relative flex flex-col items-center gap-0.5 py-1 px-3 min-w-0"
            >
              {isActive && (
                <motion.span
                  layoutId="nav-pill"
                  className="absolute inset-0 rounded-2xl"
                  style={{ background: 'rgba(212, 160, 23, 0.12)' }}
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
              <Icon
                size={22}
                strokeWidth={isActive ? 2.2 : 1.6}
                color={isActive ? '#d4a017' : 'rgba(255,255,255,0.4)'}
                className="relative z-10 transition-colors"
              />
              <span
                className="relative z-10 text-[10px] font-medium tracking-wide transition-colors"
                style={{ color: isActive ? '#d4a017' : 'rgba(255,255,255,0.4)' }}
              >
                {label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
